import PaywallModal from "../../components/PaywallModal/PaywallModal";
import { IonCol, IonContent, IonPage, IonRow } from "@ionic/react";
import "antd/dist/antd.css";
import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useSelector } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import BulkConverter from "../../components/BulkConverter";
import { useBulkImageProcessing } from "../../components/BulkConverter/useBulkImageProcessing";
import Converter from "../../components/Converter";
import { processAndAnalyzeImage } from "../../components/Converter/components/AutoUploadImage";
import Explore from "../../components/Explore";
import Editor from "../../components/SvgEditor";
import StitchEditorPage from "../StitchEditorPage";
import Sidebar from "../../components/Sidebar";
import MobileHeader from "../../components/Sidebar/MobileHeader";
import MonthlyAiUsage from "../../components/StitchEditor/MonthlyAiUsage";
import MobileHomepage from "./components/MobileHomepage";
import AppContext from "../../contexts/AppContext";
import { useProcessedImage } from "../../contexts/ProcessedImageContext";
import { setBulkMode, resetBulkConversionState } from "../../redux/slices/BulkConversion";
import { useAppDispatch } from "../../redux/store";
import Carousel1 from "./components/Carousel/Carousel"; // Import Carousel1 component
import ImageModifier from "../../components/ImageModifier";
import ImageSharpener from "../../components/ImageSharpener";
import { OnboardingOverlay, WelcomeScreen, useOnboarding } from "../../components/Onboarding";
import { TutorialTrigger } from "../../components/Tutorial";
import { useTutorial } from "../../components/Tutorial/TutorialProvider";
import { WelcomeModal, EmbroideryWelcomeModal } from "../../components/WelcomeModal";
import { SettingsModal } from "../../components/SettingsModal";
import SubscriptionPage from "../../components/SubscriptionPage/SubscriptionPage";
import EmbroideryBillingPage from "../../components/EmbroideryBillingPage/EmbroideryBillingPage";
import { useAuth } from "../../contexts/AuthContext";
import { CancelInterceptModal } from "../../components/CancelInterceptModal";
import { createPortalLinkFunc, loadReferenceArtworkForFile, storage, signOutUser } from "../../lib/firebase/firebase";
import { ref } from "firebase/storage";
import { 
  getStoredPendingFile, 
  claimPendingFile, 
  clearPendingFile,
  downloadPendingFileAsBase64,
} from "../../lib/firebase/pendingFiles";
import { analyzeImageForRetrace } from "../../lib/firebase/imageAnalysis";
import ProcessingOverlay from "../../components/ProcessingOverlay";
import { hideIntercom, showIntercom } from "../../lib/intercom/intercom";
import { importSvgAsTraced, isSvgTraceCompatible, sanitizeSvg } from "../../components/SvgEditor/helpers/importSvg";
import { setShowEditor } from "../../redux/slices/MyFiles";
import { addNewlyUploadedFile } from "../../redux/slices/UploadedFiles";
import { features, isEmbroideryTrace } from "../../config/appVariant";
import { PICK_DESIGN_STEP } from "../../tutorials";
import { executePlayground } from "../AutoDigitizePlayground/pipeline";
import { playgroundRecord } from "../AutoDigitizePlayground/storage";
import AutoDigitizeProgress, { prepareAutoDigitizeImage } from "./AutoDigitizeProgress";
import { prepareCompletionSound, playCompletionSound } from "../../lib/completionSound";
import "./index.css";

const Home = () => {
  const [previewProPaywall, setPreviewProPaywall] = useState(() =>
    process.env.NODE_ENV === 'development' && isEmbroideryTrace &&
    new URLSearchParams(window.location.search).get('previewProPaywall') === 'true');
  const [rerender, setRerender] = useState(1);
  const [svgStore, setSvgStore] = useState();
  const [converterOpen, setConverterOpen] = useState(false);
  const [image64, setImage64] = useState();
  const [referenceImage64, setReferenceImage64] = useState();
  const [imagePrompt, setImagePrompt] = useState();
  const [imageSource, setImageSource] = useState();
  const converterRef = useRef(null);
  const autoDigitizeControllerRef = useRef(null);
  const autoDigitizeResumeRef = useRef(false);
  const [imageSEO, setImageSEO] = useState();
  const [image64Resize, setImage64Resize] = useState();
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [showEmbWelcome, setShowEmbWelcome] = useState(false);
  const [debugEmptyState, setDebugEmptyState] = useState(false);
  // True between clicking the Embroidery sidebar button and the editor
  // entering Stitch mode. SvgEditorDesktop reads this from AppContext on
  // mount and clears it once consumed.
  const [pendingEmbroideryMode, setPendingEmbroideryMode] = useState(false);
  
  const { user, userIsPremium } = useAuth();
  const { setTutorialProcessedImage, setGuestProcessedImage, hasPendingProcessedImage } = useProcessedImage();
  const [fileName, setFileName] = useState();
  const [loadingConverter, setLoadingConverter] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Opening Converter...");
  const [processingStep, setProcessingStep] = useState(null); // For ProcessingOverlay
  const skipAutoConvertRef = useRef(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentView, setCurrentView] = useState('home');
  const [isImageGeneratorModalVisible, setIsImageGeneratorModalVisible] = useState(false);
  const [isImageModifierModalVisible, setIsImageModifierModalVisible] = useState(false);
  const [isImageSharpenerModalVisible, setIsImageSharpenerModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const bulkMode = useSelector((state) => state.BulkConversion.bulkMode);
  const images = useSelector((state) => state.BulkConversion.originalImages);
  const convertedCount = useSelector(
    (state) => state.BulkConversion.convertedCount
  );
  const currentFile = useSelector((state) => state.files.currentFile);
  const { setCurrentProcessingIndex } = useBulkImageProcessing();
  
  // Onboarding
  const { 
    isOnboardingActive, 
    completeOnboarding, 
    skipOnboarding 
  } = useOnboarding();
  
  // Tutorial
  const { startTutorial } = useTutorial();
  
  // Mobile header states
  const [isAccountLoading, setIsAccountLoading] = useState(false);
  const [showMobileSettingsModal, setShowMobileSettingsModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false);
  const [showEmbroideryBilling, setShowEmbroideryBilling] = useState(false);
  const [autoDigitizeRun, setAutoDigitizeRun] = useState(null);
  const [autoDigitizeBusy, setAutoDigitizeBusy] = useState(false);
  const [autoDigitizeVisible, setAutoDigitizeVisible] = useState(false);

  const handleAccountClick = () => {
    setShowSubscription(true);
  };

  const handleBillingClick = () => {
    if (isEmbroideryTrace) {
      setShowEmbroideryBilling(true);
    } else {
      setShowSubscription(true);
    }
  };

  const handleLogout = async () => {
    try {
      await signOutUser();
      window.location.href = '/signin';
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const openAutoDigitizedProject = useCallback((run) => {
    const filePath = run.filePath;
    if (!filePath) throw new Error("The project was saved, but its editor file could not be found.");
    const storageRef = ref(storage, filePath);
    const restoredFile = {
      id: run.id,
      svgMetadataId: run.id,
      name: run.name,
      filePath,
      uri: storageRef,
      type: "uploaded",
      workflow: "stitch",
      ownerUid: run.uid,
      isPublic: false,
      referenceArtwork: {
        path: run.artworkPath,
        mimeType: "image/png",
        name: run.name,
      },
    };
    dispatch(setShowEditor({ showEditor: true, currentFile: restoredFile }));
    setPendingEmbroideryMode(true);
    setSvgStore({ firebase: storageRef });
  }, [dispatch]);

  const runAutoDigitize = useCallback(async (initial, showProgress = true) => {
    const controller = new AbortController();
    autoDigitizeControllerRef.current = controller;
    setAutoDigitizeBusy(true);
    setAutoDigitizeVisible(showProgress);
    const work = () => executePlayground(initial, controller.signal, setAutoDigitizeRun);
    try {
      const finished = navigator.locks?.request
        ? await navigator.locks.request(`auto-digitize:${initial.id}`, { signal: controller.signal }, work)
        : await work();
      if (controller.signal.aborted) return;
      setAutoDigitizeRun(finished);
      setAutoDigitizeBusy(false);
      if (finished?.saved) {
        setAutoDigitizeVisible(false);
        openAutoDigitizedProject(finished);
        void playCompletionSound(`auto-digitize:${initial.id}`);
      }
    } catch (error) {
      if (error.name === "AbortError") return;
      setAutoDigitizeBusy(false);
      setAutoDigitizeRun((current) => ({
        ...current,
        error: error.message || "Trace could not finish this design.",
      }));
    }
  }, [openAutoDigitizedProject]);

  const handleAutoDigitizeFile = useCallback(async (file) => {
    if (!user?.uid || autoDigitizeBusy) return;
    prepareCompletionSound();
    try {
      const prepared = await prepareAutoDigitizeImage(file);
      const next = {
        id: crypto.randomUUID?.() || `auto-${Date.now()}`,
        uid: user.uid,
        image: prepared.image,
        name: prepared.name,
        longestSide: 96,
        processingMode: "standard",
        generateDst: false,
        source: "home",
        stage: "trace",
        startedAt: Date.now(),
        progress: "Preparing your image…",
      };
      await playgroundRecord(user.uid, next);
      setAutoDigitizeRun(next);
      await runAutoDigitize(next);
    } catch (error) {
      setAutoDigitizeRun({
        name: file?.name || "Embroidery design",
        image: "",
        stage: "trace",
        startedAt: Date.now(),
        error: error.message || "This image could not be opened.",
      });
      setAutoDigitizeVisible(true);
      setAutoDigitizeBusy(false);
    }
  }, [user?.uid, autoDigitizeBusy, runAutoDigitize]);

  const retryAutoDigitize = useCallback(async () => {
    if (!autoDigitizeRun || autoDigitizeBusy) return;
    prepareCompletionSound();
    const next = {
      ...autoDigitizeRun,
      error: null,
      cancelled: false,
      ...(autoDigitizeRun.input && !autoDigitizeRun.result
        ? {
            jobId: crypto.randomUUID?.() || `auto-job-${Date.now()}`,
            startedAt: Date.now(),
            costUsage: null,
            progress: "Retrying the saved layer plan…",
          }
        : {}),
    };
    await playgroundRecord(user.uid, next);
    setAutoDigitizeRun(next);
    await runAutoDigitize(next);
  }, [autoDigitizeRun, autoDigitizeBusy, runAutoDigitize, user?.uid]);

  const dismissAutoDigitize = useCallback(async () => {
    autoDigitizeControllerRef.current?.abort();
    setAutoDigitizeBusy(false);
    setAutoDigitizeVisible(false);
    setAutoDigitizeRun(null);
    if (user?.uid) await playgroundRecord(user.uid, null);
  }, [user?.uid]);

  useEffect(() => {
    if (!user?.uid || autoDigitizeResumeRef.current) return;
    autoDigitizeResumeRef.current = true;
    playgroundRecord(user.uid)
      .then((saved) => {
        if (saved?.source === "home" && !saved.saved && !saved.cancelled) {
          setAutoDigitizeRun(saved);
          // Restored work remains in the bottom queue instead of reopening a
          // blocking modal whenever the page remounts or hot reloads.
          runAutoDigitize(saved, false);
        }
      })
      .catch(() => {});
  }, [user?.uid, runAutoDigitize]);


  // Check if user is logging in for the first time (SvgTrace only)
  useEffect(() => {
    if (isEmbroideryTrace) return;
    const checkWelcomeModalStatus = async () => {
      console.log('🔍🔍🔍 WELCOME MODAL CHECK RUNNING 🔍🔍🔍');
      console.log('🔍 Welcome Modal Check:', { 
        user: user ? { uid: user.uid, email: user.email } : null,
        showWelcomeModal 
      });
      
      if (!user) {
        console.log('❌ No user authenticated');
        return;
      }

      try {
        // Check Firebase for survey completion status
        console.log('🔍 Checking Firebase for survey completion...');
        
        // Import Firebase functions
        const { getFirestore, doc, getDoc, query, collection, where, getDocs } = await import('firebase/firestore');
        const db = getFirestore();
        
        // Try to get user document directly by ID first
        let userDoc = null;
        try {
          const userDocRef = doc(db, 'users', user.uid);
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            userDoc = userDocSnap.data();
            console.log('✅ Found user document by ID');
          }
        } catch (error) {
          console.log('⚠️ Direct lookup failed, trying uid field search...');
        }
        
        // Fallback: search by uid field
        if (!userDoc) {
          const usersQuery = query(collection(db, 'users'), where('uid', '==', user.uid));
          const querySnapshot = await getDocs(usersQuery);
          if (!querySnapshot.empty) {
            userDoc = querySnapshot.docs[0].data();
            console.log('✅ Found user document by uid field');
          }
        }
        
        const hasCompletedSurvey = userDoc?.surveyCompleted || false;
        
        console.log('🔍 Firebase Survey Status:', {
          userDocExists: !!userDoc,
          surveyCompleted: hasCompletedSurvey,
          shouldShowModal: !hasCompletedSurvey
        });
        
        if (!hasCompletedSurvey) {
          console.log('✅✅✅ SETTING SHOW WELCOME MODAL TO TRUE (Survey not completed) ✅✅✅');
          setShowWelcomeModal(true);
        } else {
          console.log('❌ User has already completed survey');
        }
        
      } catch (error) {
        console.error('❌ Error checking Firebase survey status:', error);
        // Fallback to localStorage if Firebase check fails
        const welcomeKey = `welcome_seen_${user.uid}`;
        const hasSeenWelcome = localStorage.getItem(welcomeKey);
        
        console.log('🔄 Falling back to localStorage:', {
          welcomeKey,
          hasSeenWelcome,
          shouldShow: !hasSeenWelcome
        });
        
        if (!hasSeenWelcome) {
          console.log('✅ Setting showWelcomeModal to true (localStorage fallback)');
          setShowWelcomeModal(true);
        }
      }
    };

    checkWelcomeModalStatus();
  }, [user]);

  const handleWelcomeModalClose = () => {
    // Note: Survey completion is now tracked in Firebase via the WelcomeModal component
    // No need to set localStorage since we check Firebase for surveyCompleted status
    console.log('🔒 Welcome modal closed - survey completion tracked in Firebase');
    setShowWelcomeModal(false);
  };

  // EmbroideryTrace opens straight onto the file list, so the greeting is the
  // only thing that says what the software does and that the Academy exists.
  //
  // Shown once, and only to accounts young enough to actually be arriving for
  // the first time: the sign-up timestamp comes free from the auth token, so
  // shipping this can't ambush people who have been using the app for months.
  useEffect(() => {
    if (!isEmbroideryTrace || !user?.uid) return;
    if (localStorage.getItem(`embroiderytrace_welcome_seen_${user.uid}`)) return;

    const createdAt = Date.parse(user.metadata?.creationTime || '');
    const isNewAccount = Number.isFinite(createdAt)
      ? Date.now() - createdAt < 24 * 60 * 60 * 1000
      : false;
    if (!isNewAccount) return;

    setShowEmbWelcome(true);
  }, [user]);

  const dismissEmbWelcome = () => {
    if (user?.uid) localStorage.setItem(`embroiderytrace_welcome_seen_${user.uid}`, '1');
    setShowEmbWelcome(false);
  };

  const handleEmbWelcomeAcademy = () => {
    dismissEmbWelcome();
    startTutorial('embroidery', PICK_DESIGN_STEP);
  };

  // Embroidery deep-link: support /?embroidery=1 (also accepts &mode=embroidery)
  // so the marketing site's /image-to-embroidery iframe can drop the user into
  // the stitch workflow without an extra click. Runs once on mount.
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const wantsEmbroidery =
        params.get("embroidery") === "1" ||
        params.get("embroidery") === "true" ||
        params.get("mode") === "embroidery";
      if (wantsEmbroidery) {
        console.log("🪡 Home: ?embroidery=1 detected — entering stitch workflow");
        setPendingEmbroideryMode(true);
      }
    } catch (e) {
      console.warn("Could not read embroidery URL param:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Check for claimed file from guest converter
  useEffect(() => {
    const loadClaimedFile = async () => {
      try {
        const claimedFileJson = sessionStorage.getItem("claimedFile");
        if (!claimedFileJson) return;

        console.log("🎯 Home: Found claimed file from guest converter");
        const claimedFile = JSON.parse(claimedFileJson);

        // Clear immediately to prevent re-loading
        sessionStorage.removeItem("claimedFile");

        // Check if the claim is recent (within 5 minutes)
        const claimedAt = new Date(claimedFile.claimedAt).getTime();
        const fiveMinutesAgo = Date.now() - 5 * 60 * 1000;
        if (claimedAt < fiveMinutesAgo) {
          console.log("⚠️ Claimed file is too old, ignoring");
          return;
        }

        // If embroidery mode was requested, set the pending flag
        if (claimedFile.embroideryMode) {
          setPendingEmbroideryMode(true);
        }

        // If user wanted to open editor and we have SVG data, go directly to editor
        if (claimedFile.action === "editor" && claimedFile.pendingSvgData) {
          console.log("🎯 Home: Opening editor with claimed SVG");
          skipAutoConvertRef.current = true;
          setProcessingStep(null);
          setLoadingConverter(false);
          setImage64(claimedFile.imageData);
          setImageSource("uploaded");
          setFileName(claimedFile.fileName);
          setSvgStore(claimedFile.pendingSvgData);
          console.log("✅ Home: SVG loaded into editor");
          return;
        }

        // If we have processed image data, use it directly
        if (claimedFile.processedImage) {
          console.log("🎯 Home: Loading processed image from claimed file");
          skipAutoConvertRef.current = true;
          setGuestProcessedImage(claimedFile.processedImage);
          setImage64(claimedFile.imageData);
          setImageSource("uploaded");
          setFileName(claimedFile.fileName);
          setLoadingConverter(false);
          setProcessingStep(null);
          setConverterOpen(true);
          console.log("✅ Home: Claimed file loaded into converter");
        } else if (claimedFile.imageData) {
          console.log("🎯 Home: Claimed file has image but no processed data, processing now...");
          setImage64(claimedFile.imageData);
          setImageSource("uploaded");
          setFileName(claimedFile.fileName || "claimed-image");
          // Let the auto-convert effect handle processing
        } else {
          console.log("✅ Home: Claimed file acknowledged, available in files list");
        }
      } catch (error) {
        console.error("Error loading claimed file:", error);
        sessionStorage.removeItem("claimedFile");
        setProcessingStep(null);
        setLoadingConverter(false);
      }
    };

    // Check for saved file from GuestConverter
    const loadSavedFile = async () => {
      try {
        const savedFileJson = sessionStorage.getItem("savedFile");
        if (!savedFileJson) return;

        console.log("🎯 Home: Found saved file from converter");
        const savedFile = JSON.parse(savedFileJson);

        // Clear immediately to prevent re-loading
        sessionStorage.removeItem("savedFile");

        // Check if the save is recent (within 1 minute)
        const savedAt = new Date(savedFile.savedAt).getTime();
        const oneMinuteAgo = Date.now() - 60 * 1000;
        if (savedAt < oneMinuteAgo) {
          console.log("⚠️ Saved file is too old, ignoring");
          return;
        }

        // If embroidery mode was requested, set the pending flag
        if (savedFile.embroideryMode) {
          setPendingEmbroideryMode(true);
        }

        // If user wanted to open editor, do that
        if (savedFile.action === "editor" && savedFile.filePath) {
          console.log("🎯 Home: Opening editor with saved file:", savedFile.filePath);
          // Reconstruct the storage reference from the file path
          const storageRef = ref(storage, savedFile.filePath);
          const referenceArtwork = await loadReferenceArtworkForFile({
            filePath: savedFile.filePath,
            svgMetadataId: savedFile.svgMetadataId,
            referenceArtwork: savedFile.referenceArtwork,
          });
          const restoredFile = {
            id: savedFile.fileId || savedFile.svgMetadataId,
            svgMetadataId: savedFile.svgMetadataId,
            name: savedFile.fileName,
            filePath: savedFile.filePath,
            uri: storageRef,
            url: savedFile.url,
            type: savedFile.type || "uploaded",
            workflow: savedFile.workflow || (savedFile.embroideryMode ? "stitch" : "vector"),
            ownerUid: user?.uid,
            isPublic: false,
            referenceArtwork,
          };
          
          // Make sure loading states are reset
          setLoadingConverter(false);
          setConverterOpen(false);
          
          dispatch(setShowEditor({ showEditor: true, currentFile: restoredFile }));
          setSvgStore({ firebase: storageRef });
          console.log("✅ Home: Editor opened with saved file");
        } else {
          console.log("✅ Home: File saved successfully, showing in files list");
        }
      } catch (error) {
        console.error("Error loading saved file:", error);
        sessionStorage.removeItem("savedFile");
      }
    };

    // Only run when user is authenticated
    if (user) {
      loadClaimedFile();
      loadSavedFile();
    }
  }, [user]);

  // Claim pending file ONLY after Stripe redirect (when URL has claimPending param)
  // This handles the case where user signed up/in, subscribed via Stripe, and was redirected back
  useEffect(() => {
    const claimPendingFileAfterStripe = async () => {
      // Only proceed if user is authenticated AND premium
      if (!user || !userIsPremium) {
        return;
      }

      // Check URL for claimPending query param (from Stripe success redirect)
      const urlParams = new URLSearchParams(window.location.search);
      const claimPendingId = urlParams.get("claimPending");
      
      // ONLY auto-claim if we have the URL param (definite Stripe redirect)
      // Don't auto-claim from localStorage alone - it might be stale
      if (!claimPendingId) {
        // Clean up any stale localStorage data older than 5 minutes
        const storedPending = getStoredPendingFile();
        if (storedPending) {
          const storedTime = new Date(storedPending.storedAt).getTime();
          const fiveMinutesAgo = Date.now() - 5 * 60 * 1000;
          if (storedTime < fiveMinutesAgo) {
            console.log("🗑️ Home: Clearing stale pending file from localStorage");
            clearPendingFile();
          }
        }
        return;
      }

      console.log("🎯 Home: Found pending file to claim after Stripe redirect:", claimPendingId);

      try {
        // Claim the file
        const claimResult = await claimPendingFile(claimPendingId);
        console.log("✅ Home: Pending file claimed:", claimResult);

        // Download the image
        if (claimResult.previewUrl) {
          console.log("📥 Home: Downloading claimed file image...");
          setProcessingStep("upload");
          setLoadingConverter(true);
          const imageData = await downloadPendingFileAsBase64(claimResult.previewUrl);
          
          // Process the image (includes AI color detection)
          console.log("⚙️ Home: Processing claimed image...");
          setProcessingStep("colors");
          const processedImage = await processAndAnalyzeImage(imageData);
          
          // Run AI analysis to determine if retrace is needed
          try {
            console.log("🤖 Home: Running AI analysis on claimed image...");
            setProcessingStep("analyze");
            const aiAnalysis = await analyzeImageForRetrace(imageData);
            console.log("🤖 Home: AI Analysis result:", aiAnalysis);
            
            if (aiAnalysis.needsRetrace) {
              processedImage.wasUpscaled = true;
              processedImage.upscaleReason = aiAnalysis.hasGradients ? 'gradients' : 'ai-analysis';
            }
          } catch (aiError) {
            console.warn("🤖 Home: AI analysis failed:", aiError);
          }
          
          setProcessingStep("ready");
          
          // Set up the converter
          setGuestProcessedImage(processedImage);
          setImage64(imageData);
          setImageSource("uploaded");
          setFileName("claimed-image");
          setConverterOpen(true);
          
          console.log("✅ Home: Claimed file loaded into converter");
        }

        // Clear the pending file from storage
        clearPendingFile();

        // Clean up URL params
        const newUrl = window.location.pathname;
        window.history.replaceState({}, "", newUrl);
      } catch (error) {
        console.error("Failed to claim pending file:", error);
        clearPendingFile();
        setProcessingStep(null);
        setLoadingConverter(false);
        
        const newUrl = window.location.pathname;
        window.history.replaceState({}, "", newUrl);
      }
    };

    claimPendingFileAfterStripe();
  }, [user, userIsPremium, setGuestProcessedImage, setImage64, setImageSource, setFileName, setConverterOpen]);

  // Console handles for states that are otherwise a pain to reach — a fresh
  // account's welcome, and the empty file list. Development only: nothing a
  // customer can trip over.
  if (process.env.NODE_ENV !== 'production') {
    window.forceShowWelcomeModal = () => setShowWelcomeModal(true);
    window.forceShowEmbWelcome = () => setShowEmbWelcome(true);
    window.toggleDebugEmptyState = () => setDebugEmptyState((previous) => !previous);
  }

  const contextValue = useMemo(
    () => ({
      svgStore,
      setSvgStore,
      image64,
      setImage64,
      referenceImage64,
      setReferenceImage64,
      imagePrompt,
      setImagePrompt,
      imageSource,
      setImageSource,
      imageSEO,
      setImageSEO,
      image64Resize,
      setImage64Resize,
      fileName,
      setFileName,
      // Tutorial support
      tutorialMode: false,
      setTutorialMode: () => {},
      processTutorialImage: async (imageData) => {
        console.log('🎯 processTutorialImage: Starting with imageData length:', imageData?.length);
        console.log('🎯 processTutorialImage: imageData preview:', imageData?.substring(0, 100));
        
        try {
          // Set the image64 in context first
          setImage64(imageData);
          setFileName('tutorial_sample.png');
          setImageSource('uploaded');
          
          console.log('🎯 processTutorialImage: Context values set');
          
          // NEW APPROACH: Directly process the image without relying on button clicks
          // This bypasses the timing issues with conditional rendering and context updates
          
          console.log('🎯 processTutorialImage: Processing image directly...');
          setProcessingStep("upload");
          setLoadingConverter(true);
          
          try {
            // Process the image directly using the imported function
            const result = await processAndAnalyzeImage(imageData);
            console.log('✅ processTutorialImage: Image processed successfully:', result);
            
            setProcessingStep("colors");
            
            // Run AI analysis to determine if retrace is needed
            try {
              console.log("🤖 processTutorialImage: Running AI analysis...");
              setProcessingStep("analyze");
              const aiAnalysis = await analyzeImageForRetrace(imageData);
              console.log("🤖 processTutorialImage: AI Analysis result:", aiAnalysis);
              
              if (aiAnalysis.needsRetrace) {
                result.wasUpscaled = true;
                result.upscaleReason = aiAnalysis.hasGradients ? 'gradients' : 'ai-analysis';
              }
            } catch (aiError) {
              console.warn("🤖 processTutorialImage: AI analysis skipped for tutorial:", aiError);
            }
            
            setProcessingStep("ready");
            
            // Store the processed data in context for the converter to pick up
            // (replaces window.tutorialProcessedImage global variable)
            setTutorialProcessedImage(result);
            
            // Open the converter
            setConverterOpen(true);
            console.log('🎯 processTutorialImage: Converter opened');
            
            // Wait for converter to initialize
            await new Promise(resolve => setTimeout(resolve, 1500));
            
            // Try to trigger the AutoUploadImage button after converter is open
            // This is a backup in case the converter needs the button click
            setTimeout(() => {
              const autoUploadButton = document.getElementById("AutoConvertUpload");
              if (autoUploadButton) {
                console.log('🎯 processTutorialImage: Found button after converter open, clicking...');
                autoUploadButton.click();
              }
            }, 500);
            
            return { success: true };
          } catch (processError) {
            console.error('❌ processTutorialImage: Failed to process image directly:', processError);
            
            // Fallback: Try the old button approach
            console.log('🎯 processTutorialImage: Falling back to button click approach...');
            
            // Wait for context to update
            await new Promise(resolve => setTimeout(resolve, 500));
            
            const autoUploadButton = document.getElementById("AutoConvertUpload");
            if (autoUploadButton) {
              console.log('🎯 processTutorialImage: Clicking button...');
              autoUploadButton.click();
              
              // Wait for converter to open
              await new Promise(resolve => setTimeout(resolve, 2000));
              
              return { success: true };
            } else {
              // Final fallback: Just open the converter
              setConverterOpen(true);
              console.log('🎯 processTutorialImage: Opening converter as final fallback');
              return { success: false, reason: 'Could not process image' };
            }
          }
        } catch (error) {
          console.error('❌ processTutorialImage: Failed to process image:', error);
          throw error;
        }
      },
      // Debug mode for UI testing
      debugEmptyState,
      setDebugEmptyState,
      pendingEmbroideryMode,
      setPendingEmbroideryMode,
    }),
    [svgStore, image64, referenceImage64, imagePrompt, imageSource, imageSEO, image64Resize, fileName, debugEmptyState, converterOpen, pendingEmbroideryMode, setImage64, setConverterOpen, setFileName, setImageSource, setTutorialProcessedImage]
  );

  // Capture the user's upload before any in-converter retrace/cleanup tool
  // replaces image64 with a processed derivative.
  useEffect(() => {
    if (isEmbroideryTrace && image64 && !converterOpen && !svgStore) {
      setReferenceImage64(image64);
    }
  }, [image64, converterOpen, svgStore]);

  const handleAutoConvertClick = () => {
    // Wait for the button to be rendered, then click it
    const tryClick = (attempts = 0) => {
      const button = document.getElementById("AutoConvertUpload");
      if (button) {
        button.click();
      } else if (attempts < 10) {
        // Retry after a short delay (button may not be rendered yet)
        setTimeout(() => tryClick(attempts + 1), 100);
      } else {
        console.error("❌ AutoConvertUpload button not found after 10 attempts");
        setProcessingStep(null);
        setLoadingConverter(false);
      }
    };
    tryClick();
  };

  const handleResizeImageClick = () => {
    document.getElementById("ResizerInput").click();
  };

  const handleBulkConvertClick = () => {
    if (isEmbroideryTrace) return;
    document.querySelector('input[type="file"][multiple]')?.click();
  };

  const handleGenerateImageClick = () => {
    if (isEmbroideryTrace) return;
    setIsImageGeneratorModalVisible(true);
  };

  const handleSharpenImageClick = () => {
    setIsImageSharpenerModalVisible(true);
  };

  const handleModifyImageClick = () => {
      setIsImageModifierModalVisible(true);
  };

  const [isImportingSvg, setIsImportingSvg] = useState(false);
  const [svgImportProgress, setSvgImportProgress] = useState("");

  /**
   * Process an uploaded SVG File. Routed here from the regular upload entry
   * points (Sidebar, MobileHomepage, UploadSection) whenever the detected
   * file type is image/svg+xml.
   *
   * Fast path: SvgTrace-stamped or structurally-simple SVGs load directly.
   * Slow path: anything else (gradients, embedded images, text, …) goes
   * through the rasterize-and-retrace pipeline.
   */
  const processSvgFile = useCallback(async (file) => {
    if (!file) return;
    setIsImportingSvg(true);
    setSvgImportProgress("Reading file...");

    try {
      const svgString = sanitizeSvg(await file.text());

      const compat = isSvgTraceCompatible(svgString);
      let finalSvg;
      if (compat.compatible) {
        setSvgImportProgress(
          compat.reason === "marker"
            ? "Detected SvgTrace file — loading..."
            : "Compatible SVG — loading directly...",
        );
        finalSvg = svgString;
      } else {
        const result = await importSvgAsTraced(svgString, (_stage, detail) => {
          setSvgImportProgress(detail);
        });
        finalSvg = result.svg;
      }

      const localFile = {
        id: `svg_import_${Date.now()}`,
        name: file.name.replace(/\.svg$/i, "") || `imported_${Date.now()}`,
        uri: null,
        url: null,
        type: "uploaded",
        workflow: pendingEmbroideryMode ? "stitch" : "vector",
        ownerUid: user?.uid,
        isPublic: false,
        isLocalOnly: true,
        svgData: finalSvg,
      };

      dispatch(setShowEditor({ showEditor: true, currentFile: localFile }));
      setSvgStore({ svg: finalSvg });
      setPendingEmbroideryMode(false);
    } catch (err) {
      console.error("SVG import failed:", err);
    } finally {
      setIsImportingSvg(false);
      setSvgImportProgress("");
    }
  }, [user, dispatch, setSvgStore, pendingEmbroideryMode, setPendingEmbroideryMode]);

  const handleSidebarNavigation = (view) => {
    setCurrentView(view);
    setSidebarOpen(false); // Close sidebar on mobile after navigation
    
    // Handle specific navigation actions
    switch (view) {
      case 'create':
        // Trigger create action - could open image generator or file upload
        document.querySelector('.pill-button')?.click(); // Click first action button
        break;
      case 'home':
        // Reset to home view
        skipAutoConvertRef.current = false;
        setSvgStore(undefined);
        setConverterOpen(false);
        break;
      case 'projects':
        // Navigate to projects/files view
        break;
      case 'templates':
        // Navigate to templates
        break;
      case 'ai':
        // Open AI image generator
        document.querySelector('[data-action="generate"]')?.click();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    // Skip auto-convert if editor is open, converter is open, or already processing
    if (image64 && !converterOpen && !svgStore && processingStep === null) {
      // Skip if this image was already loaded via claimed file / editor path
      if (skipAutoConvertRef.current) {
        console.log("⏭️ Skipping auto-convert - image already processed via claimed file");
        return;
      }
      if (hasPendingProcessedImage()) {
        console.log("⏭️ Skipping auto-convert - pending processed image exists");
        return;
      }
      
      console.log("🚀 Home: Starting auto-convert for new image");
      // The shared converter already knows how to open its result in the Stitch
      // Editor. EmbroideryTrace uses that route by default instead of silently
      // bypassing the traced-SVG review screen.
      if (isEmbroideryTrace) setPendingEmbroideryMode(true);
      setProcessingStep("upload");
      setLoadingConverter(true);
      handleAutoConvertClick();
    }
  }, [image64, converterOpen, svgStore, hasPendingProcessedImage, processingStep]);

  // Reset loading state when converter opens OR closes
  useEffect(() => {
    if (converterOpen) {
      // Converter opened - clear processing overlay
      setProcessingStep(null);
      setLoadingConverter(false);
    } else {
      // Converter closed - also clear overlay and reset loading
      setProcessingStep(null);
      setLoadingConverter(false);
    }
  }, [converterOpen]);

  useEffect(() => {
    if (image64Resize) {
      handleResizeImageClick();
    }
  }, [image64Resize]);

  // Bulk convert is SvgTrace-only — clear any stale queue on EmbroideryTrace.
  useEffect(() => {
    if (!isEmbroideryTrace) return;
    dispatch(resetBulkConversionState());
  }, [dispatch]);

  useEffect(() => {
    if (isEmbroideryTrace) return;
    if (images.length >= 2) {
      dispatch(setBulkMode(true));
      setLoadingConverter(true);
    }
  }, [images, dispatch, isEmbroideryTrace]);

  useEffect(() => {
    if (isEmbroideryTrace) return;
    if (images.length >= 2 && images.length === convertedCount) {
      setConverterOpen(true);
    }
    const loadingMsg = document.querySelector('[id^="loading-"][id$="-msg"]');
    if (images.length >= 2 && loadingMsg) {
      loadingMsg.textContent = `Converting images (${convertedCount}/${images.length})...`;
    }
  }, [images, convertedCount, isEmbroideryTrace]);

  // Add/remove sidebar-visible class based on whether sidebar should be shown
  useEffect(() => {
    const shouldShowSidebar = svgStore === undefined && !converterOpen;
    if (shouldShowSidebar) {
      document.body.classList.add('sidebar-visible');
    } else {
      document.body.classList.remove('sidebar-visible');
    }
    
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('sidebar-visible');
    };
  }, [svgStore, converterOpen]);

  // Hide Intercom on converter, editor, and loading screens — only show on main files page
  useEffect(() => {
    const isMainPage = svgStore === undefined && !converterOpen && processingStep === null;
    if (isMainPage) {
      showIntercom();
    } else {
      hideIntercom();
    }
    return () => showIntercom();
  }, [svgStore, converterOpen, processingStep]);

  // Handle processing overlay completion
  const handleProcessingComplete = useCallback(() => {
    setProcessingStep(null);
    setLoadingConverter(false);
  }, []);

  return (
    <IonPage>
      {previewProPaywall && <PaywallModal isVisible isAuthenticated isPremium={false} previewOnly action="ai-toolkit" onClose={() => setPreviewProPaywall(false)} />}
      {/* SVG Import overlay */}
      {isImportingSvg && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(255,255,255,0.9)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            zIndex: 9999,
            fontFamily: "Clash Grotesk, sans-serif",
          }}
        >
          <div style={{
            width: "36px", height: "36px", borderRadius: "50%",
            border: "3px solid #e0e0e0", borderTopColor: "#7c3aed",
            animation: "spin 0.8s linear infinite",
            marginBottom: "20px",
          }} />
          <div style={{ fontSize: "16px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>
            Importing SVG...
          </div>
          <div style={{ fontSize: "13px", color: "#888", maxWidth: "260px", textAlign: "center" }}>
            {svgImportProgress}
          </div>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      )}

      {/* Processing Overlay - shows step-by-step progress with blur over converter */}
      <ProcessingOverlay
        isVisible={processingStep !== null}
        currentStep={processingStep || "upload"}
        previewImage={image64}
        onComplete={handleProcessingComplete}
      />
      
      <AppContext.Provider value={contextValue}>
        {/* Show sidebar only on homepage (not converter or editor) */}
        {svgStore === undefined && !converterOpen && (
          <Sidebar 
            isOpen={sidebarOpen} 
            setIsOpen={setSidebarOpen}
            onNavigate={handleSidebarNavigation}
            onResizeImage={handleResizeImageClick}
            onBulkConvert={handleBulkConvertClick}
            onGenerateImage={handleGenerateImageClick}
            onSharpenImage={handleSharpenImageClick}
            onModifyImage={handleModifyImageClick}
            onSvgFile={processSvgFile}
            setImage64={setImage64}
            setFileName={setFileName}
            onBillingClick={handleBillingClick}
          />
        )}

        {/* The converter and editor hide the sidebar, so the credit shop needs its
            own mount there or Retrace/Modify exhaustion has nowhere to open. */}
        {isEmbroideryTrace && (svgStore !== undefined || converterOpen) && (
          <MonthlyAiUsage placement="headless" />
        )}

        {svgStore === undefined && images.length < 2 && !bulkMode && (
          <Converter
            loadingConverter={loadingConverter}
            setLoadingConverter={setLoadingConverter}
            setLoadingMessage={setLoadingMessage}
            setProcessingStep={setProcessingStep}
            converterOpen={converterOpen}
            setConverterOpen={setConverterOpen}
          />
        )}
        {!isEmbroideryTrace && (images.length >= 2 || bulkMode) && converterOpen && (
          <BulkConverter
            setLoadingConverter={setLoadingConverter}
            setConverterOpen={setConverterOpen}
            setCurrentProcessingIndex={setCurrentProcessingIndex}
          />
        )}
        {svgStore === undefined && !converterOpen && (
          <>
            {/* Mobile Header - only show on mobile */}
            <div className="mobile-only">
              <MobileHeader 
                onAccountClick={handleAccountClick}
                isAccountLoading={isAccountLoading}
                onSettingsClick={() => setShowMobileSettingsModal(true)}
                onLogout={handleLogout}
                onBillingClick={handleBillingClick}
              />
            </div>
            
            <IonContent className="ion-padding mobile-content">
              {/* Mobile Homepage - Hero Cards */}
              <div className="mobile-only">
                <MobileHomepage
                  onGenerateImageClick={handleGenerateImageClick}
                  onResizerClick={handleResizeImageClick}
                  onModifyClick={handleModifyImageClick}
                  onSvgFile={processSvgFile}
                  setImage64={setImage64}
                  setFileName={setFileName}
                  setImageSource={setImageSource}
                  onAutoDigitizeFile={handleAutoDigitizeFile}
                  autoDigitizeBusy={autoDigitizeBusy}
                />
              </div>
              
              {/* Use Carousel1 here and pass necessary props */}
              <Carousel1
                // data={someData} // Ensure you define 'someData' or the appropriate prop
                isUpload={true}
                setImage64={setImage64}
                setFileName={setFileName}
                setImage64Resize={setImage64Resize}
                setRerender={setRerender}
                rerender={rerender}
                fileName={fileName}
                isImageGeneratorModalVisible={isImageGeneratorModalVisible}
                setIsImageGeneratorModalVisible={setIsImageGeneratorModalVisible}
              />
              <div style={{ paddingTop: "0px", overflow: "hidden" }}>
                <IonRow>
                  <IonCol>
                    <Explore 
                      setRerender={setRerender} 
                      rerender={rerender}
                      setIsImageGeneratorModalVisible={setIsImageGeneratorModalVisible}
                      onSvgFile={processSvgFile}
                      onAutoDigitizeFile={handleAutoDigitizeFile}
                      autoDigitizeBusy={autoDigitizeBusy}
                    />
                  </IonCol>
                </IonRow>
              </div>
            </IonContent>
          </>
        )}
        {svgStore !== undefined && (
          isEmbroideryTrace
            ? <StitchEditorPage />
            : (pendingEmbroideryMode || currentFile?.workflow === "stitch")
              ? <StitchEditorPage />
              : <Editor />
        )}

        <AutoDigitizeProgress
          run={autoDigitizeRun}
          busy={autoDigitizeBusy}
          visible={autoDigitizeVisible}
          onMinimize={() => setAutoDigitizeVisible((value) => !value)}
          onRetry={retryAutoDigitize}
          onClose={dismissAutoDigitize}
        />

        {/* Subscription Management Page */}
        {showSubscription && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
            background: 'linear-gradient(135deg, #f0f4f8 0%, #e8eff6 40%, #f5f7fa 100%)',
            overflowY: 'auto',
            paddingTop: 'var(--ion-safe-area-top, env(safe-area-inset-top, 44px))',
          }}>
            <SubscriptionPage onBack={() => setShowSubscription(false)} />
          </div>
        )}

        {/* EmbroideryTrace Billing Page */}
        {showEmbroideryBilling && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
            background: 'linear-gradient(135deg, #f0f4f8 0%, #e8eff6 40%, #f5f7fa 100%)',
            overflowY: 'auto',
            paddingTop: 'var(--ion-safe-area-top, env(safe-area-inset-top, 44px))',
          }}>
            <EmbroideryBillingPage onBack={() => setShowEmbroideryBilling(false)} />
          </div>
        )}
        
        {/* Welcome Screen - Feature-selling onboarding (SvgTrace only) */}
        {!isEmbroideryTrace && (
          <WelcomeScreen
            isVisible={isOnboardingActive}
            onComplete={completeOnboarding}
            onSkip={skipOnboarding}
          />
        )}

        {/* First-time user welcome modal (SvgTrace only) */}
        {!isEmbroideryTrace && (
          <WelcomeModal
            isVisible={showWelcomeModal}
            onClose={handleWelcomeModalClose}
            userName={user?.displayName || user?.email?.split('@')[0]}
            userId={user?.uid}
          />
        )}

        {isEmbroideryTrace && (
          <EmbroideryWelcomeModal
            isVisible={showEmbWelcome}
            onClose={dismissEmbWelcome}
            onStartAcademy={handleEmbWelcomeAcademy}
            userName={user?.displayName?.split(' ')[0] || user?.email?.split('@')[0]}
          />
        )}

        {/* Image Sharpener Modal */}
        <ImageSharpener
          isModalVisible={isImageSharpenerModalVisible}
          setIsModalVisible={setIsImageSharpenerModalVisible}
        />

        {/* Image Modifier Modal */}
        <ImageModifier
          isModalVisible={isImageModifierModalVisible}
          setIsModalVisible={setIsImageModifierModalVisible}
        />

        {/* Mobile Settings Modal */}
        <SettingsModal
          isOpen={showMobileSettingsModal}
          onClose={() => setShowMobileSettingsModal(false)}
        />

        <CancelInterceptModal
          open={showCancelModal}
          onClose={() => setShowCancelModal(false)}
        />

      </AppContext.Provider>
    </IonPage>
  );
};

export default Home;
